import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByWorkCategories(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES,dtConfig[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES].getReportsFinanceByWorkCategories,
    {
      urlParams: {
        companyId: companyId,
      },
      params: query,
    },
  )
}

export default {
  getReportsFinanceByWorkCategories
}